<script setup lang="ts">
import { computed } from 'vue';
import type { FieldSchema } from '../../../types';

const props = withDefaults(
  defineProps<{
    field?: FieldSchema;
    class?: string;
  }>(),
  {
    class: '',
  }
);

const classes = computed(() => props.field?.settings?.class || props.class);
</script>

<template>
  <p :class="['text-sm', classes]">{{ field?.value }}</p>
</template>
